<template>
  <div v-if="loaded" class="uk-container">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item :href="'/administration/members/' + associationInfo.member.bookNum + '/info'">{{associationInfo.member.fName}} {{associationInfo.member.lName}}</vk-breadcrumb-item>
      <vk-breadcrumb-item>{{formatAssociation(associationType)}} Detail</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>
      {{formatAssociation(associationType)}} Detail
      <router-link class="uk-margin-small-right" :to="'/administration/associations/' + associationType + '/' + associationId + '/edit/'" v-vk-tooltip.bottom="'Edit ' + formatAssociation(associationType)"><vk-icon icon="pencil" ratio="1"></vk-icon></router-link>
      <a v-vk-tooltip.bottom="'Delete ' + formatAssociation(associationType)"><vk-icon icon="minus-circle" ratio="1" v-on:click="showDeleteModal = true"></vk-icon></a>
    </h1>
    <h2>{{formatAssociation(associationType)}} Entry</h2>
    <h4 class="uk-text-bold">Union Member Name</h4>
    <p>{{associationInfo.member.fName}} {{associationInfo.member.lName}}</p>
    <h4 class="uk-text-bold">{{formatAssociation(associationType)}} Date</h4>
    <p>{{formatDate(associationInfo.date)}}</p>
    <h4 class="uk-text-bold">Description</h4>
    <p>{{associationInfo.description}}</p>
    <div v-if="associationType === 'bookings'">
      <h4 class="uk-text-bold">Currently Employed</h4>
      <p>{{(associationInfo.currentlyEmployed) ? "Yes" : "No"}}</p>
    </div>
    <vk-modal :show.sync="showDeleteModal">
      <vk-modal-title>Are you sure you want to delete this {{associationType.slice(0,-1)}}?</vk-modal-title>
      <p class="uk-text-right">
        <vk-button @click="showDeleteModal = false" class="uk-margin-small-right">Cancel</vk-button>
        <vk-button type="primary" @click="deleteAssociation">Delete</vk-button>
      </p>
    </vk-modal>
  </div>
</template>

<script>
import AssociationsApi from "@/utils/api/associations";

export default {
  name: "AssociationInfo",
  data() {
    return {
      loaded: false,
      associationType: this.$route.params.association,
      associationId: this.$route.params.id,
      associationInfo: null,
      showDeleteModal: false,
      prevPath: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevPath = from.fullPath));
  },
  created() {
    AssociationsApi.getAssociation(
      this.$cookie.get("iwl_apiToken"),
      this.associationType,
      this.associationId
    )
      .then(res => {
        this.associationInfo = res[0];
        this.loaded = true;
      })
      .catch(err => console.log(err));
  },
  methods: {
    formatAssociation(text) {
      return text.charAt(0).toUpperCase() + text.slice(1, -1);
    },
    formatDate(date) {
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        hour: "numeric",
        minute: "numeric"
      });
    },
    deleteAssociation() {
      AssociationsApi.deleteAssociation(
        this.$cookie.get("iwl_apiToken"),
        this.associationType,
        this.associationId
      )
        .then(member => {
          this.showDeleteModal = false;
          this.$router.push(this.prevPath);
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style scoped>
h4 {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin_association_info.vue